// import "./App.css";
import { useNavigate } from "react-router-dom";

import useBreadcrumb from "../../Utils/useBreadcrumb";
import BreadcrumbNav from "../../Components/BreadcrumbNav/BreadcrumbNav";
import "../../Components/BreadcrumbNav/BreadcrumbNav.css";

// import ItemPathFilter from "./components/FilterSidebar/ItemPathFilter";
import BlockerZ from "../BlockerZ/BlockerZ";
import Favorites from "./components/Favorites/Favorites";
// import ActionButton from "./components/ActionButton";
// import logo from "./assets/dslogo.png";
// import img from "../../Assets/Images/Landing/training.png";
// import CoachingBuddyImg from "../../Assets/NewCoachingBuddyimg.png"
import CoachingBuddyImg from "../../Assets/NewLogo.png";
import { useEffect, useState, useRef } from "react";
// import { useEffect, useState, useRef } from "react";
import Dropdown from "./components/Dropdown/Dropdown";
import HelpDropdown from "./components/Dropdown/HelpDropdown";
import BranchDropdown from "./components/Dropdown/BranchDropdown";
import Sidebar from "./components/Sidebar/Sidebar";
import CreateRole from "../CreateRole/CreateRole";
import EmployeeRegistration from "../EmployeeRegistration/RegistrationForm";
import StudentRegistration from "../StudentRegistration/StudentRegistrationForm";
// import UpdatedStudentReg from "../StudentRegistration/UpdatedStdReg/UpdatedStudentReg"
import LocationIcon from "../../Assets/Images/CommanImages/location.png";
import DPPPerformance from "../Reports/DPPPerformance/DPPPerformance";
import DPPSubjectCount from "../Reports/BatchSubjectwiseDPPCount/BatchSubjectCount";
import ClassFeedback from "../Reports/ClassFeedback/ClassFeedback";
// import ReportWhatsapp from "../SendReportToParents/ReportWhatsapp";
// import OnlyDown from "../../Assets/Images/CommanImages/downOnly.png";
// import StarSquare from "../../Assets/Images/CommanImages/starSquare.png";
import Search from "../../Assets/Images/CommanImages/searchyellow.png";
import QuestionSecondPage from "../Parser/QuestionSecondPage";
import { Routes, Route, Link } from "react-router-dom";
import StudentLogo from "./../../Assets/Images/CommanImages/studentforsearch.png";
// redux store
import { useSelector } from "react-redux";
// import { ManageRole } from "../ManageRole/ManageRole";
import { useDispatch } from "react-redux";
import { fetchApiData } from "../../Redux/features/Landing/landingSlice";
import AssignUserToRole from "../AssignUserToRole/AssignUserToRole";
import UserSettings from "../UserSettings/UserSettings";
import Profile from "../Profile/Profile";
import AssignDPP from "../AssignTest/Assigntest";
import CreateBatch from "../CreateBatch/CreateBatch";
import BatchDashboard from "../BatchDashboard/BatchDashboard";
import AssignBatch from "../CreateBatchV2/AssignBatch";
import EditCreateBatch from "../CreateBatch/EditCreateBatch";
import UploadQuestions from "../UploadQuestions/UploadQuestions";
import UserReg from "../UserReg/UserReg";
import Home from "../Home/Home";
import AttendanceReport from "../Reports/DummyReportPage/AttendanceReport";
import AssignTest from "../ScheduleTest/ScheduleTest";
import NewTestSeries from "../CreateNTS/newTestSeries";
import GenerateOTLC from "../OTC/OTC";
// import AssignTest from "../AssignTest/Assigntest";
import UOD from "../UploadOmrData/UOD";
// import CreateBatchv2 from "../AssignBatch/CreateBacthV2";
// import CreateBatchV2 from "../CreateBatchV2/CreateBacthV2";
import UserManagement from "../UserManagement/UserManagement";
// import { FULL_API_BASE_URL } from "../../Config/Config"
import Pop from "../POP/pop";
import TestCreate from "../TestCreate/TestCreate";
import QuestionPaperCorrection from "../QuestionPaperCorrection/QuestionPaperCorrection";
import TimeTable from "../ClassTimeTableSchedule/TimeTable";
import StudentFees from "../StudentsFees/StudentFee";
import NewFeePlan from "../StudentsFees/NewFeePlan";

import ReportManagement from "../ReportManagement/ReportManagement";
import ReportCard from "../ReportCard/ReportCard";
import { FULL_API_BASE_URL } from "../../Config/Config";
// import ReportFeatures from "../ReportManagement/ReportFeatures ";
import TestReportCard from "../Reports/TestReportCard/TestReportCard";
// import SecondTableCompoenent from "../Reports/TestReportCard/SecondTableCompoenent";
import ReportWhatsapp from "../SendReportToParents/ReportWhatsapp";
import DppBatchSubwiseStatus from "../Reports/DppBatchSubwiseStatus/DppBatchSubwiseStatus";
import GenerateResult from "../GenerateResult/GenerateResult";
import DPPSummary from "../Reports/StudentDppSummary/StudentDPPSummary";
import StudentDashBoard from "../StudentDashboard/studentdashboard";
import CreateTestSection from "../TestModule/CreateTestSection";
import TestSectionManagement from "../TestSectionManagement/TestSectionManagement";
import NTSV2 from "../CreateNTS-V2/ntsv2";
import TSD from "../TestSeriesDashboard/TSD";
import ParseQuestionDashboard from "../Parser/QuestionDashboard/QuestionDashboard";
import ParseDeleteQuestionDashboard from "../Parser/QuestionDashboard/DeleteQuestionDashboard";
import ReviewerDashboard from "../Parser/ReviewerDashboard/Facultyv2Dashboard";
import HoDDashboard from "../Parser/HODDashboard/HODv2Dashboard";
import HoDv2Dashboard from "../Parser/HODDashboard/HODv2Dashboard";
import QuestionBank from "../Parser/QuesBankDashboard/QuestionBank";
// import ParseBulkQuestion from "../Parser/ParseBulkQuestions/ParseBulkQuestion";
// import ReviewQuestion from "../Parser/ParseQuestionReview/ReviewQuestion"
import ReviewQuestion from "../Parser/ReviewQuestion/ReviewQuestion";
import PublishSingleQuestion from "../Parser/PublishSingleQuestion/PSQMainFile";
import POP2 from "../POP/pop2";
import POP3 from "../POP/pop3";
import ParseBulkQuestion from "../Parser/ParseBulkQuestions/ParseBulkQuestion";
import LevelReview from "../Parser/LevelReview/LevelReview";
import SearchBarStudent from "./SearchBarStudent";
import TESTRQ from "../Parser/ReviewQuestion/TESTRQ";
import CreateQuesPaper from "../../Pages/CreateQuestionsPaper/CurateQuestionPaper/CreateQuesPaper";
import FacultyReview from "../Parser/FacultyReview/FacultyReview";

import QuestionPaperDetail from "../CreateQuestionsPaper/QuestionPaperDetails/QuestionPaperDetail";
import Success from "../../Assets/Images/CommanImages/success.png";
import HodReview from "../Parser/HodReview/HodReview";
import QuestionBankReview from "../Parser/QuestionBankReview/QuestionBankReview";
import DashboardCreateQuestionpaper from "../CreateQuestionsPaper/DashboardCreateQuestionpaper/DashboardCQP";
import QuestionPaperDashboard from "../CreateQuestionsPaper/QuestionPaperDashboard/QuestionPaperDashboard";
import Facultyv2Dashboard from "../Parser/ReviewerDashboard/Facultyv2Dashboard";
// import HODv2Dashboard from "../Parser/HODDashboard/HODv2Dashboard";
import TestScheduling from "../CreateQuestionsPaper/TestScheduling/TestScheduling";
import DppScheduling from "../CreateQuestionsPaper/DppScheduling/DppScheduling";
import DPPDashboardSchedule from "../CreateQuestionsPaper/DPPDashboard/DppDashboard";
import TestDashboardSchedule from "../CreateQuestionsPaper/TestDashboardSchedule/TestDashboardSchedule";

import DPPScheduleClone from "../CreateQuestionsPaper/DppScheduling/DPPScheduleClone";
import DPPDashboardSchedulev2 from "../Scheduling/DPP/DPPScheduleDashboard";
import AssignorDashbord from "../CreateQuestionsPaper/AssignorDashboard/AssignorDashbord";
import CurateQuestionPaperEdit from "../CreateQuestionsPaper/CurateQuestionPaperEdit/CurateQuestionPaperEdit";
import ReviewerQuesPaperDashboard from "../CreateQuestionsPaper/ReviewerQuesPaperDashboard/ReviewerQuesPaperDashboard";
import TestPaperBonusCorrection from "../TestPaperBonusCorrection/TestPaperBonusCorrection";
import PreviewQuesPaper from "../CreateQuestionsPaper/PreviewQuesPapers/PreviewQuesPaper";
import TestScheduleview from "../CreateQuestionsPaper/TestScheduling/TestScheduleClone";
import RevieweQuestionPaper from "../CreateQuestionsPaper/ReviewQuestionPaper/ReviewQuestionPaper";
import TestResultDashboard from "../TestResultDashboard/TestResultDashboard";
import UploadOmrV2 from "../UploadOmrData/UploadOmrV2";
import StudentGroup from "../StudentGrouph/StudentGroup";
import StudentGroupDashboard from "../StudentGrouph/StudentGroupDashboard";
// import UserDashboard from "../UserDashboard/UserDashboard";
import UserEditFromDashboard from "../UserDashboard/UserEditFromDashboard/UserEditFromDashboard";
// import TestMarkCorrection from "../"
// import UserGroupsDashboard from "../UserGroups/UserGroupsDashboard";
import UserGroupsFromDashboard from "../UserGroups/UserGroupfromDashboard/UserGroupfromDashboard";
import StudentGroupEdit from "../StudentGrouph/StudentGroupEdit";
import CreateGroups from "../UserGroups/CreateGroupFromDashboard/CreateGroupFromDashboard";
import CreateRoleDashboard from "../CreateRole/CreateRoleDashboard/CreateRoleDashboard";
import NewCreateRole from "../CreateRole/NewCreateRole/NewCreateRole";
import UpdatedCreateRole from "../CreateRole/UpdatedCreateRole/UpdateCreateRole";
import UpdatedAssignUserToRole from "../AssignUserToRole/UpdatedAssignToRole/UpdatedAssignToRole";
import UserDashboard from "../UpdatedUserGroups/UserGroupManagementDashboards/UserDashboard";
import CreateUserGroups from "../UpdatedUserGroups/CreateUserGroup/CreateUserGroups";
import UserGroupsDashboard from "../UserGroups/UpdatedUserGroupsDashboard/UserGroupsDashboard";
import UpdatedCreateUserGroup from "../UserGroups/UpdatedCreateUserGroup/UpdatedCreateUserGroup";
import ManageGroupAccess from "../UpdatedUserGroups/ManageGroupAccess/ManageGroupAccess";
import ManageGroupEmployee from "../UserGroups/ManageGroupEmployee/ManageGroupEmployee";
import UserGroupRoleAccess from "../UserGroups/UserGroupRoleAccess/UserGroupRoleAccess";
import UserGroupDetails from "../UserGroups/UserGroupDetails/UserGroupDetails";
import NotificationConfigDashboard from "../NotificationConfiguration/NotificationConfigurationDashboard/NotificationConfigDashboard";
import NotificationConfigurationStudentAttendence from "../NotificationConfiguration/NotificationConfigurationStudentAttendence/NotificationConfigurationStudentAttendence";
import { use } from "react";
import JsonToLatex from "../POP/JsonToLatex";
import StudentDashboard from "../StudentRegistration/StudentRegistrationDashboard/StudentDashboard";
import DPPSchedulingNotification from "../CreateQuestionsPaper/DPPSchedulingNotification/DPPSchedulingNotification";
import IncompleteDppReport from "../Reports/IncompleteDppReport/IncompleteDppReport";
import StudentTestPerformanceReport from "../Reports/StudentPerformance/StudentPerformance";
import StudentRegEdit from "../StudentRegistration/StudentRegistrationEdit/StudentRegEdit";
import NewStudentDashboard from "../NewStudentDashboards/NewStudentDashboard";
import StudentProgressTrend from "../Reports/StudentProgressTrend/StudentProgressTrend";
import ComputerBasedTestDashboard from "../CBT/ComputerBasedTestDashboard/ComputerBasedTestDashboard";
import ComputerBasedTestScheduling from "../CBT/ComputerBasedTestScheduling/ComputerBasedTestScheduling";
import TemRegDetailsReports from "../../Pages/Reports/TemRegDetailsReports/TemRegDetailsReports";
// import RecordPaymentDashboard from "../PaymentRecord/RecordPaymentDashboard/RecordPaymentDashboard";
import PaymentRecord from "../PaymentRecord/PaymentRecord/PaymentRecord";
import StudentFeeDashboard from "../PaymentRecord/StudentFeeDashboard/StudentFeeDashboard";

import PdfViewer from "../UploadPDF/PdfViewer";
import EditFeePlan from "../StudentsFees/EditFeePlan";
import FeePlanStatusDashboard from "../FeePlanStatusDashboard/FeePlanStatusDashboard";
import FeePaymentDashboard from "../FeePaymentDashboard/FeePaymentDashboard";
import EnquiryReport from "../Reports/EnquiryReport/EnquiryReport";
import PDCSReport from "../Reports/PDCSReports/PDCSReport";
import PendingFeePlanReport from "../Reports/PendingFeePlan/PendingFeePlanReport";
import CashbookReport from "../Reports/CashbookDashboard/CashbookReport";
import QuickTestScheduling from "../QuickQuesPapers/QuickTestScheduling";
import QuickDPPSchedulingDashboard from "../QuickQuesPapers/QuickDPPSchedulingDashboard";


function Landing({ setAuthenticated, setIsLoggedOut }) {
  const navigate = useNavigate();

  const [messageBox, setMessageBox] = useState("this message box");
  const [isMessageBoxVisible, setIsMessageBoxVisible] = useState(false);
  const [messageBoxHeight, setMessageBoxHeight] = useState("10vh"); // default height
  const [noTimeSet, setNoTimeSet] = useState(false);
  const [imgActive, setActiveImg] = useState();
  const [selectedStudentId, setSelectedStudentID] = useState("");
  const [loaderOrNot, setLoaderOrNot] = useState(false);
  const [showCloseButton, setShowCloseButton] = useState(false);
  // const [messageBox, setMessageBox] = useState("this message box");
  // const [isMessageBoxVisible, setIsMessageBoxVisible] = useState(false);
  // const [imgActive, setActiveImg] = useState();
  const timerRef = useRef(null); // Timer reference
  const [isBlockerEnabled, setIsBlockerEnabled] = useState(true);
  useEffect(() => {
    const handleSecurityToggle = (e) => {
      if (e.altKey && e.key.toLowerCase() === "a") {
        setIsBlockerEnabled((prev) => !prev);
        // Show feedback in message box
        // setMessageBox(`Security measures ${!isBlockerEnabled ? 'enabled' : 'disabled'}`);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Security measures : {!isBlockerEnabled ? "enabled" : "disabled"}
              </span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setActiveImg(Success);
        e.preventDefault(); // Prevent default Alt+A behavior
      }
    };

    document.addEventListener("keydown", handleSecurityToggle);
    return () => document.removeEventListener("keydown", handleSecurityToggle);
  }, [isBlockerEnabled, setMessageBox, setIsMessageBoxVisible]);

  // ADDED THE LOGIC TO STAY MESSAGE BOX ON SCREEN
  useEffect(() => {
    if (isMessageBoxVisible) {
      pauseTimer(); // clear any existing timer
      if (!noTimeSet) {
        timerRef.current = setTimeout(() => {
          setIsMessageBoxVisible(false);
        }, 3500); // auto-close after 3.5s
      }
    }
    return () => clearTimeout(timerRef.current);
  }, [isMessageBoxVisible, noTimeSet]);

  // Timer management
  const startTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current); // Clear any existing timer before starting a new one
    }
    if (!noTimeSet) {
      timerRef.current = setTimeout(() => {
        setIsMessageBoxVisible(false);
      }, 3500); // Timer duration (3 seconds)
    }
  };

  const pauseTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current); // Clear the timer to pause
    }
  };

  const resumeTimer = () => {
    startTimer(); // Resume the timer by starting it again
  };

  const handleCloseMessageBox = () => {
    setIsMessageBoxVisible(false);
    pauseTimer();
  };

  useEffect(() => {
    if (isMessageBoxVisible) {
      startTimer(); // Start the timer when the message box is shown
    }
  }, [isMessageBoxVisible]);

  const handleMessageChange = (event) => {
    setMessageBox(event.target.value);
    setIsMessageBoxVisible(true);
  };
  // const [pagePath, setPagePath] = useState("");
  // const [routes, setRoutes] = useState([]);
  const [isOpen, setIsOpen] = useState(true);

  const toggleSidebarMAIN = () => {
    setIsOpen(!isOpen);
  };

  // const [pagePath, setPagePath] = useState(() => {
  //   return localStorage.getItem("pagePath") || "Home";
  // });
  // const [routes, setRoutes] = useState([]);

  // // Save pagePath to localStorage whenever it changes
  // useEffect(() => {
  //   localStorage.setItem("pagePath", pagePath);
  // }, [pagePath]);

  // useEffect(() => {
  //   // Save pagePath to localStorage whenever it changes
  //   localStorage.setItem("pagePath", pagePath);
  // }, [pagePath]);

  // Use the new breadcrumb hook for synchronized navigation
  const { pagePath, breadcrumbSegments, setPagePath, navigateToSegment } =
    useBreadcrumb();

  const [routes, setRoutes] = useState([]);

  // console.log("routes", routes);

  //redux store
  const { data } = useSelector((state) => state.landing);

  const dispatch = useDispatch();

  useEffect(() => {
    const userId =
      localStorage.getItem("userId") || sessionStorage.getItem("userId");
    const clientId =
      localStorage.getItem("clientId") || sessionStorage.getItem("clientId");
    const clientBranchId =
      localStorage.getItem("clientBranchId") ||
      sessionStorage.getItem("clientBranchId");
    // const clientBranchId =
    //   localStorage.getItem("clientBranchId") || sessionStorage.getItem("clientBranchId");
    // if (userId && clientId && clientBranchId) {
    //   dispatch(fetchApiData({ userId, clientId, clientBranchId }));
    // }
    if (userId && clientId && clientBranchId) {
      dispatch(fetchApiData({ userId, clientId, clientBranchId }));
    }
  }, [dispatch]);

  // const dynamicLogoPath = "dsc_bpl.png";
  // console.log("landing new data :::", data)
  const dynamicLogoPathOne = data ? `${data.client_schema_name[7]}.png` : "";

  // const dynamicLogoPathOne = "dsc_bpl.png";

  // const institute_name = "Definite Success Classes";
  // const branch_name = "Kasturba Nagar, Bhopal";

  // if (data){
  //   console.log("branch_name", data.client_schema_name[6][0].br_display_name)
  // }

  const dynamicBranchName =
    data && data.client_schema_name?.[6]?.[0]?.br_display_name;
  const institute_name =
    data?.client_schema_name?.[6]?.[0]?.client_display_name ?? "";

  // sidebar resize
  const [sidebarVisible, setSidebarVisible] = useState(true);

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  useEffect(() => {
    // Define the media query
    const mediaQuery = window.matchMedia("(max-width: 1200px)");

    // Function to toggle the sidebar visibility based on the media query
    const handleMediaQueryChange = (event) => {
      setSidebarVisible(!event.matches);
    };

    // Add the listener for media query changes
    mediaQuery.addEventListener("change", handleMediaQueryChange);

    // Call the handler right away so state gets updated with the initial value
    handleMediaQueryChange(mediaQuery);

    // Remove the listener on cleanup
    return () =>
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
  }, []);
  //////////////searchbar code
  const [searchKey, setSearchKey] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  useEffect(() => {
    const handleSearch = async () => {
      if (searchKey && searchKey.length >= 3) {
        try {
          const response = await fetch(
            `${FULL_API_BASE_URL}/get-student-by-search-key/?search_key=${searchKey}`,
            {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            }
          );
          const data = await response.json();
          setSearchResults(data);
        } catch (error) {
          console.error(error);
        }
      } else {
        setSearchResults([]); // Clear the search results when searchKey is empty
      }
    };

    handleSearch();
  }, [searchKey]); // This will run the effect when `searchKey` changes

  // useEffect(() => {
  //   const handleUnload = () => {
  //     // Clear specific item from local storage
  //     localStorage.setItem("pagePath", "Home");

  //     // Or clear all local storage
  //     // localStorage.clear();

  //     // console.log('Local storage cleared.');
  //   };

  //   window.addEventListener("unload", handleUnload);

  //   // Cleanup event listener on component unmount
  //   return () => {
  //     window.removeEventListener("unload", handleUnload);
  //   };
  // }, []);

  // Dynamically create elements based on the ui_element string
  const createElement = (componentName, props = {}) => {
    const components = {
      EmployeeRegistration,
      StudentRegistration,
      AssignDPP,
      UserReg,
      CreateRole,
      AssignUserToRole,
      UploadQuestions,
      CreateBatch,
      GenerateOTLC,
      NewTestSeries,
      UOD,
      QuestionPaperCorrection,
      AssignBatch,
      AttendanceReport,
      AssignTest,
      TestCreate,
      UserManagement,
      TimeTable,
      StudentFees,
      ReportManagement,
      ReportCard,
      setMessageBox,
      setIsMessageBoxVisible,
      setActiveImg,
      StudentDashBoard,
      NTSV2,
      ReviewQuestion,
      LevelReview,
      PublishSingleQuestion,
      HodReview,
      HoDv2Dashboard,
      TestScheduling,
      DashboardCreateQuestionpaper,
      TSD,
      FacultyReview,
      DppScheduling,
      QuestionBankReview,
      ParseDeleteQuestionDashboard,
      TESTRQ,
      ParseQuestionDashboard,
      QuestionSecondPage,
      TestReportCard,
      DppBatchSubwiseStatus,
      ReportWhatsapp,
      DPPPerformance,
      DPPSubjectCount,
      Facultyv2Dashboard,
      ClassFeedback,
      DPPSummary,
      CreateTestSection,
      TestSectionManagement,
      ParseBulkQuestion,
      ReviewerDashboard,
      HoDDashboard,
      QuestionBank,
      CreateQuesPaper,
      QuestionPaperDetail,
      DPPDashboardSchedule,
      DPPScheduleClone,
      TestDashboardSchedule,
      TestPaperBonusCorrection,
      AssignorDashbord,
      ReviewerQuesPaperDashboard,
      TestScheduleview,
      RevieweQuestionPaper,
      TestResultDashboard,
      UploadOmrV2,
      UserDashboard,
      StudentGroupDashboard,
      CreateRoleDashboard,
      UserGroupsDashboard,
      NotificationConfigDashboard,
      StudentDashboard,
      StudentFeeDashboard,
      ComputerBasedTestDashboard,
      NewFeePlan,
      EditFeePlan,
      FeePlanStatusDashboard,
      FeePaymentDashboard,
      EnquiryReport,
      PDCSReport,
    };

    const Component = components[componentName];
    return Component ? (
      <Component
        {...props}
        setMessageBox={setMessageBox}
        messageBox={messageBox}
        setIsMessageBoxVisible={setIsMessageBoxVisible}
        setActiveImg={setActiveImg}
        setShowCloseButton={setShowCloseButton}
        setNoTimeSet={setNoTimeSet}
      />
    ) : null;
  };

  // const handleSelectStudentId = (studentID) => {
  //   setSelectedStudentID(studentID);
  // };

  const handleSelectStudentId = (studentID) => {
    setSelectedStudentID(studentID);
    navigate("/student_dashboard"); // <-- This will route the user
  };

  return (
    <div className="main">
      {isBlockerEnabled && <BlockerZ />}
      <div className="main-one">
        {/* LOGO */}
        <div className="navbar-logo-block">
          <Link to="/" onClick={() => setPagePath("Home")}>
            <div>
              <img
                src={
                  process.env.PUBLIC_URL + `/client_logos/${dynamicLogoPathOne}`
                }
                alt="DSC Bhopal Logo"
                className="ds-logo-navbar"
              />
            </div>
          </Link>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            marginLeft: "2%",
          }}
        >
          {/* BRANCH */}
          <div style={{ height: "100%" }}>
            <div className="branch-div-landing">
              <p
                // style={{
                //   fontSize: "30px",
                //   marginBottom: "5px",
                //   marginTop: "-11px",
                //   fontWeight: "700",
                // }}
                className="institute-name-text"
              >
                {institute_name}
              </p>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <img
                  // style={{ height: "24px", width: "24px" }}
                  className="location-icon-navbar"
                  src={LocationIcon}
                  alt="location"
                />
                <BranchDropdown text={dynamicBranchName} />
              </div>
            </div>
          </div>

          {/* ICONS AND AVATARS */}
          <div style={{}}>
            <div className="icons">
              <div className="iconOne">
                <div className="notificationDotOne">
                  {data && data.client_schema_name[4]}
                </div>
              </div>
              <div className="iconTwo">
                <div className="notificationDotTwo">
                  {data && data.client_schema_name[3]}
                </div>
              </div>
              <div className="iconThree">
                <HelpDropdown />
              </div>
              <div className="">
                <Dropdown
                  setAuthenticated={setAuthenticated}
                  setPagePath={setPagePath}
                  setIsLoggedOut={setIsLoggedOut}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="main-two">
        {/* <div className="subone">
          <ItemPathFilter />
        </div> */}
        {sidebarVisible && (
          <Sidebar setPagePath={setPagePath} setRoutes={setRoutes} />
        )}

        <div className="subtwo">
          <button className="togglebtn" onClick={toggleSidebar}>
            .
            <br />
            . <br /> .{/* {sidebarVisible ? "<" : ">"} */}
          </button>
          <div className="subtwoa lan-flex">
            <div className="My-fav-dropdwon">
              <Favorites setPagePath={setPagePath} />
            </div>
            <div className="subtwoa-2">
              {/* <input className="searchbar-landing" type="text" placeholder=" Search" /> <img style={{height: "px" , width: "1vw"}} src={Search} alt="" /> */}
              {/* ///////////////////////// */}
              {/* <SearchBarStudent /> */}
              <SearchBarStudent onSelectStudentID={handleSelectStudentId} />
              {/* <div className="searchbar-container">
                <input
                  type="text"
                  placeholder="Type here to search"
                  name="search"
                  className="searchbar-landing"
                  onChange={(e) => setSearchKey(e.target.value)}
                  onFocus={() => setIsDropdownVisible(true)}
                  onBlur={() =>
                    setTimeout(() => setIsDropdownVisible(false), 200)
                  }
                />
                <img
                  src={Search}
                  className="searchbar-img-landing"
                  alt="addition"
                />
                {isDropdownVisible && searchResults.length > 0 && (
                  <div className="search-results-dropdown">
                    {searchResults.map((result, index) => (
                      <div key={index} className="search-result-item">
                        <p className="first-item-student">
                          {" "}
                          <img
                            src={StudentLogo}
                            style={{
                              height: "25px",
                              width: "25px",
                              marginRight: "4px",
                            }}
                            alt=""
                          />
                          {result.student_full_name}
                        </p>
                        <p
                          style={{ marginTop: "5px" }}
                          className="second-item-student"
                        >
                          {" "}
                          Batch: {result.batch_name}
                        </p>

                        <p className="second-item-student">
                          {" "}
                          Roll No: {result.roll_number}{" "}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
              </div> */}
            </div>
            {/* ///////////////////////// */}
          </div>
          {/* {isMessageBoxVisible && (
            <div className="Messages-For-All">
              <div className="Message-Contents">
                <div style={{ display: "flex", gap: "5px" }}>
                  {loaderOrNot ? (
                    <div className="loader"></div>
                  ) : (
                    <img
                      className="Active-image-messagebox"
                      style={{ width: "20px", height: "20px" }}
                      src={imgActive}
                      alt=""
                    />
                  )}

                  <p>{messageBox}</p>
                </div>
              </div>
            </div>
          )} */}
          {/* {isMessageBoxVisible && (
            <div
              className="Messages-For-All"
              onMouseEnter={pauseTimer} // Pause the timer on hover
              onMouseLeave={resumeTimer} // Resume the timer when leaving the box
            >
              <div
                className="Message-Contents"
                style={{ height: messageBoxHeight }}
              >
                <div style={{ display: "flex", gap: "5px" }}>
                  {loaderOrNot ? (
                    <div className="loader"></div>
                  ) : (
                    <img
                      className="Active-image-messagebox"
                      style={{
                        width: "20px",
                        height: "20px",
                        ...(imgActive ? {} : { display: "none" }), // Hide the image if imgActive is falsy
                      }}
                      src={imgActive || ""} // Use an empty string as a fallback src
                      alt=""
                    />
                  )}
                  <p>{messageBox}</p>
                </div>
              </div>
            </div>
          )} */}

          {/* {isMessageBoxVisible && (
            <div
              className="Messages-For-All"
              onMouseEnter={pauseTimer}
              onMouseLeave={resumeTimer}
            >
              <div
                className="Message-Contents"
                style={{ height: messageBoxHeight }}
              >
                <div style={{ display: "flex", gap: "5px", alignItems: "center", width: "100%" }}>
                  <div style={{ display: "flex", gap: "5px", alignItems: "center", flex: 1 }}>
                    {loaderOrNot ? (
                      <div className="loader"></div>
                    ) : (
                      <img
                        className="Active-image-messagebox"
                        style={{
                          width: "20px",
                          height: "20px",
                          ...(imgActive ? {} : { display: "none" }),
                        }}
                        src={imgActive || ""}
                        alt=""
                      />
                    )}
                    <p style={{ margin: 0 }}>{messageBox}</p>
                  </div>
                  <span onClick={handleCloseMessageBox}> X </span>
                </div>
              </div>
            </div>
          )} */}

          {isMessageBoxVisible && (
            <div
              className="Messages-For-All"
              onMouseEnter={pauseTimer}
              onMouseLeave={resumeTimer}
            >
              <div
                className="Message-Contents"
                style={{ height: messageBoxHeight }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "flex-start",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      alignItems: "center",
                      flex: 1,
                    }}
                  >
                    {loaderOrNot ? (
                      <div className="loader"></div>
                    ) : (
                      <img
                        className="Active-image-messagebox"
                        style={{
                          width: "20px",
                          height: "20px",
                          ...(imgActive ? {} : { display: "none" }),
                        }}
                        src={imgActive || ""}
                        alt=""
                      />
                    )}
                    <p style={{ margin: 0 }}>{messageBox}</p>
                  </div>
                  {showCloseButton && (
                    <span
                      onClick={handleCloseMessageBox}
                      style={{
                        cursor: "pointer",
                        fontSize: "20px",
                        fontWeight: "bold",
                        lineHeight: "1",
                        marginTop: "-2px",
                        marginLeft: "-5px",
                      }}
                    >
                      X
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* ///////////////////////// */}
          <div className="subtwob lan-flex">
            {/* <div className="subtwob-1"> */}
            {/* Administration {">"} Question Bank {">"} Manual Entry */}
            {/* {pagePath} */}
            {/* </div> */}
            <div className="subtwob-1">
              <BreadcrumbNav
                segments={breadcrumbSegments}
                onNavigate={(segment) => {
                  // Optional: Add any tracking or additional logic here
                  console.log("Navigating to:", segment.name);
                }}
              />
            </div>
            <div className="subtwob-2">{/* <ActionButton /> */}</div>
          </div>
          <div className="subtwoc">
            {/* <img src={img} alt="" style={{ width: "300px", height: "300px" }} /> */}

            <Routes>
              <Route
                path="/"
                element={
                  <Home
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />

              <Route
                path="/studentdashboard"
                element={
                  <StudentDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setMessageBoxHeight={setMessageBoxHeight}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />

              <Route
                path="/student_registration"
                element={
                  <StudentRegistration
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setMessageBoxHeight={setMessageBoxHeight}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />

              <Route
                path="/student_registration_edit"
                element={
                  <StudentRegEdit
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setMessageBoxHeight={setMessageBoxHeight}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />

              {/* <Route
                path="/updated_new_student_registration"
                element={
                  <UpdatedStudentReg
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setMessageBoxHeight={setMessageBoxHeight}
                  />
                }
              /> */}
              <Route
                path="/employee_registration"
                element={
                  <EmployeeRegistration
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setMessageBoxHeight={setMessageBoxHeight}
                  />
                }
              />
              <Route
                path="/user_settings"
                element={
                  <UserSettings
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setMessageBoxHeight={setMessageBoxHeight}
                    setPagePath={setPagePath}
                  />
                }
              />
              <Route
                path="/profile"
                element={
                  <Profile
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setMessageBoxHeight={setMessageBoxHeight}
                    setPagePath={setPagePath}
                    setIsLoggedOut={setIsLoggedOut}
                    setAuthenticated={setAuthenticated}
                  />
                }
              />
              {/* <Route
                path="/employee_registration"
                element={<EmployeeRegistration />}
              />
              <Route
                path="/student_registration"
                element={<StudentRegistration />}
              />
              <Route
                path="/assign_test"
                element={<Assigntest dataClient={data} />}
              /> */}

              {/* <Route
                path="/user_registration"
                element={<UserReg dataClient={data} />}
              /> */}
              {/* 
              <Route
                path="/user_registration"
                element={<UserReg dataClient={data} />}
              />
              <Route
                path="/create_role"
                element={<CreateRole dataClient={data} />}
              />
              <Route
                path="/assign_user_to_role"
                element={<AssignUserToRole dataClient={data} />}
              />
              <Route path="/upload_answer" element={<UploadQuestions />} />

              <Route path="/create_batch" element={<CreateBatch />} /> */}
              {/* <Route path="/schedule_test" element={<AssignTest />} />  */}
              {/* <Route path="/attendance_report" element={<AttendanceReport />} /> */}
              {/* <Route path="/NewTestSeries" element={<NewTestSeries dataClient={data}/>} /> */}
              {/* <Route path="/upload_omr_data" element={<UOD />} /> */}
              {/* <Route path="/Assign_batch" element={<CreateBatchV2 />} />                              */}
              {/* <Route path="/time_table" element={<TimeTable />} /> */}
              {/* <Route path="/user_management" element={<UserManagement />} /> */}
              <Route
                path="/pop"
                element={
                  <Pop
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/batch_dashboard"
                element={
                  <BatchDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />
              <Route
                path="/assign_batch"
                element={
                  <AssignBatch
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />
              <Route
                path="/create_batch"
                element={
                  <CreateBatch
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/create_batch_edit"
                element={
                  <EditCreateBatch
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              {/* <Route
                path="/student_dashboard"
                element={
                  <StudentDashBoard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    selectedStudentID={selectedStudentId}
                  />
                }
              /> */}
              <Route
                path="/review_question_paper"
                element={
                  <RevieweQuestionPaper
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    selectedStudentID={selectedStudentId}
                  />
                }
              />
              <Route
                path="/testscheduling"
                element={
                  <TestScheduling
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    selectedStudentID={selectedStudentId}
                  />
                }
              />
              <Route
                path="/ntsv2"
                element={
                  <NTSV2
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/tsd"
                element={
                  <TSD
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/json_to_latex"
                element={
                  <JsonToLatex
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/pop2"
                element={
                  <POP2
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/DashboardCreateQuestionpaper"
                element={
                  <DashboardCreateQuestionpaper
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />
              <Route
                path="/otc"
                element={
                  <GenerateOTLC
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                    setShowCloseButton={setShowCloseButton}
                  />
                }
              />
              <Route
                path="/generate_otlc"
                element={
                  <GenerateOTLC
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                    setShowCloseButton={setShowCloseButton}
                  />
                }
              />
              <Route
                path="/pop3"
                element={
                  <POP3
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/level_review"
                element={
                  <LevelReview
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              {/* <Route
                path="/user_groups_dashboard"
                element={
                  <UserGroupsDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              /> */}
              {/* <Route
                path="/user_groups_from_dashboard"
                element={
                  <UserGroupsFromDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              /> */}
              <Route
                path="/faculty_review"
                element={
                  <FacultyReview
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/dpp_scheduling"
                element={
                  <DppScheduling
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/user_from_dashboard_edit"
                element={
                  <UserEditFromDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              {/* <Route
                path="/user_dashboard"
                element={
                  <UserDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              /> */}
              <Route
                path="/Test_scheduling_dashboard"
                element={
                  <TestDashboardSchedule
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />
              <Route
                path="/DPPSchedule_Clone"
                element={
                  <DPPScheduleClone
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              {/* <Route
                path="/dppdashboardschedulev2"
                element={
                  <DPPDashboardSchedulev2
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              /> */}
              <Route
                path="/hodv2_dashboard"
                element={
                  <HoDv2Dashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />
              <Route
                path="/question_bank_review"
                element={
                  <QuestionBankReview
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/hod_review"
                element={
                  <HodReview
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />

              <Route
                path="/set_dashboard"
                element={
                  <ParseQuestionDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />
              <Route
                path="/ques_dashboard"
                element={
                  <ParseDeleteQuestionDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/question_review"
                element={
                  <ReviewQuestion
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/TESTRQ"
                element={
                  <TESTRQ
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/publish_single_question"
                element={
                  <PublishSingleQuestion
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/question_review"
                element={
                  <ReviewQuestion
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/questionsecondpage"
                element={
                  <QuestionSecondPage
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/generate_result"
                element={<GenerateResult dataClient={data} />}
              />
              <Route
                path="/report_management"
                element={
                  <ReportManagement
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setPagePath={setPagePath}
                  />
                }
              />
              <Route
                path="/test_report_card"
                element={
                  <TestReportCard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setPagePath={setPagePath}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />
              <Route
                path="/test_paper_bonus_correction"
                element={
                  <TestPaperBonusCorrection
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/DPP_Batch_Sub_Status"
                element={
                  <DppBatchSubwiseStatus
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setPagePath={setPagePath}
                  />
                }
              />
              <Route
                path="/DPP_Dashboard_Schedule"
                element={
                  <DPPDashboardSchedule
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />
              <Route
                path="question_paper_dashboard"
                element={
                  <QuestionPaperDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="report_whatsapp"
                element={
                  <ReportWhatsapp
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/Student_DPP_Performance"
                element={
                  <DPPPerformance
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setPagePath={setPagePath}
                  />
                }
              />
              <Route
                path="/incomplete_dpp_report"
                element={
                  <IncompleteDppReport
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setPagePath={setPagePath}
                  />
                }
              />
              <Route
                path="/student_test_performance_report"
                element={
                  <StudentTestPerformanceReport
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setPagePath={setPagePath}
                  />
                }
              />
              <Route
                path="/Batch_Sub_DPP_Count"
                element={
                  <DPPSubjectCount
                    dataClient={data}
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setPagePath={setPagePath}
                  />
                }
              />
              <Route
                path="/faculty_v2_dashboard"
                element={
                  <Facultyv2Dashboard
                    dataClient={data}
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setPagePath={setPagePath}
                  />
                }
              />
              <Route
                path="/class_feedback"
                element={
                  <ClassFeedback
                    dataClient={data}
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setPagePath={setPagePath}
                  />
                }
              />
              <Route path="/report_card" element={<ReportCard />} />
              {/* {routes.map(({ ui_path, ui_element }) => (
                console.log(ui_path,ui_element)
              ))} */}
              {/* {routes.map(({ ui_path, ui_element }) => (
                <Route
                  key={ui_path}
                  path={ui_path}
                  element={createElement(ui_element, { dataClient: data })}
                  setMessageBox={setMessageBox}
                  messageBox={messageBox}
                  setIsMessageBoxVisible={setIsMessageBoxVisible}
                  setActiveImg={setActiveImg}
                  setLoaderOrNot={setLoaderOrNot}
                />
              ))} */}
              {routes.map(({ ui_path, ui_element }) => (
                <Route
                  key={ui_path}
                  path={ui_path}
                  element={createElement(ui_element, {
                    dataClient: data,
                    setMessageBox,
                    messageBox,
                    setIsMessageBoxVisible,
                    setActiveImg,
                    setLoaderOrNot,
                    setPagePath,
                  })}
                />
              ))}

              {/* <Route
                path="/dpp_batch_subwise_status"
                element={<DppBatchSubwiseStatus dataClient={data} />}
              /> */}
              <Route
                path="/dppstatus"
                element={
                  <DPPSummary
                    dataClient={data}
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setPagePath={setPagePath}
                  />
                }
              />
              <Route
                path="/test_section"
                element={
                  <CreateTestSection
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/test_section_management"
                element={
                  <TestSectionManagement
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/parse_bulk_questions"
                element={
                  <ParseBulkQuestion
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />
              <Route
                path="/reviewer_dashboard"
                element={
                  <ReviewerDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />
              <Route
                path="/hod_dashboard"
                element={
                  <HoDDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/TestScheduleview"
                element={
                  <TestScheduleview
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                  />
                }
              />

              <Route
                path="/questionbank"
                element={
                  <QuestionBank
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />
              <Route
                path="/upload_omr_data_v2"
                element={
                  <UploadOmrV2
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                    pauseTimer={pauseTimer}
                  />
                }
              />
              <Route
                path="/curate_ques_paper"
                element={
                  <CreateQuesPaper
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/question_paper_details"
                element={
                  <QuestionPaperDetail
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    setMessageBoxHeight={setMessageBoxHeight}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/assignor_dashboard_details"
                element={
                  <AssignorDashbord
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/curate_question_paper_edit"
                element={
                  <CurateQuestionPaperEdit
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/reviewer_ques_paper_dashboard"
                element={
                  <ReviewerQuesPaperDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/preview_ques_paper"
                element={
                  <PreviewQuesPaper
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/test_result_dashboard"
                element={
                  <TestResultDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />

              {/* <Route
                path="/create_groups_from_dashboard"
                element={
                  <CreateGroups
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              /> */}
              <Route
                path="/student_group_dashboard"
                element={
                  <StudentGroupDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/student_group"
                element={
                  <StudentGroup
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/student_group_edit"
                element={
                  <StudentGroupEdit
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/create_role_dashboard"
                element={
                  <CreateRoleDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/new_create_role"
                element={
                  <NewCreateRole
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/update_create_role"
                element={
                  <UpdatedCreateRole
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/update_assign_user_to_role"
                element={
                  <UpdatedAssignUserToRole
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/user_dashboard"
                element={
                  <UserDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/updated_user_group"
                element={
                  <CreateUserGroups
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              {/* <Route
                path="/updated_user_groups_dashboard"
                element={
                  <UpdatedUserGroupsDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              /> */}
              <Route
                path="/user_groups_dashboard"
                element={
                  <UserGroupsDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />
              <Route
                path="/updated_create_user_group"
                element={
                  <UpdatedCreateUserGroup
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/manage_group_access"
                element={
                  <ManageGroupAccess
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/user_group_role_access"
                element={
                  <UserGroupRoleAccess
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/user_group_details"
                element={
                  <UserGroupDetails
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/manage_group_employee"
                element={
                  <ManageGroupEmployee
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/notification_config_dashboard"
                element={
                  <NotificationConfigDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                  />
                }
              />
              <Route
                path="/configuration_notification_student_attendence"
                element={
                  <NotificationConfigurationStudentAttendence
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                    setMessageBoxHeight={setMessageBoxHeight}
                  />
                }
              />
              <Route
                path="/create_dpp_schedule_notification"
                element={
                  <DPPSchedulingNotification
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setNoTimeSet={setNoTimeSet}
                    dataClient={data}
                    setMessageBoxHeight={setMessageBoxHeight}
                  />
                }
              />
              <Route
                path="/student_dashboard"
                element={
                  <NewStudentDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    setMessageBoxHeight={setMessageBoxHeight}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                    selectedStudentID={selectedStudentId}
                  />
                }
              />
              <Route
                path="/student_progress_trend"
                element={
                  <StudentProgressTrend
                    setMessageBox={setMessageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setPagePath={setPagePath}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />
              <Route
                path="/cbt_dashboard"
                element={
                  <ComputerBasedTestDashboard
                    setMessageBox={setMessageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setPagePath={setPagePath}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />
              <Route
                path="/cbt_scheduling"
                element={
                  <ComputerBasedTestScheduling
                    setMessageBox={setMessageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setPagePath={setPagePath}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />
              <Route
                path="/tem_reg_details"
                element={
                  <TemRegDetailsReports
                    setMessageBox={setMessageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setPagePath={setPagePath}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />
              <Route
                path="/new_fee_plan"
                element={
                  <NewFeePlan
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                    setShowCloseButton={setShowCloseButton}
                  />
                }
              />
              {/* <Route
                path="/record_payment_dashboard"
                element={
                  <RecordPaymentDashboard
                    setMessageBox={setMessageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setPagePath={setPagePath}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              /> */}
               <Route
                path="/student_fee_dashboard"
                element={
                  <StudentFeeDashboard
                    setMessageBox={setMessageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setPagePath={setPagePath}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />
              <Route
                path="/record_payment"
                element={
                  <PaymentRecord
                    setMessageBox={setMessageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setPagePath={setPagePath}
                    setNoTimeSet={setNoTimeSet}
                  />
                }
              />

               <Route
                path="/pdf_viewer"
                element={
                  <PdfViewer
                    setMessageBox={setMessageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setPagePath={setPagePath}
                    setNoTimeSet={setNoTimeSet}
                    />
                }
              />

              <Route
                path="/edit_fee_plan"
                element={
                  <EditFeePlan
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                    setShowCloseButton={setShowCloseButton}
                  />
                }
              />
                <Route
                path="/fee_plan_dashboard"
                element={
                  <FeePlanStatusDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                    setShowCloseButton={setShowCloseButton}
                  />
                }
              />
              <Route
                path="/fee_payment_dashboard"
                element={
                  <FeePaymentDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                    setShowCloseButton={setShowCloseButton}
                  />
                }
              />
              <Route
                path="/enquiry_reports"
                element={
                  <EnquiryReport
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                    setShowCloseButton={setShowCloseButton}
                    setPagePath={setPagePath}
                  />
                }
              />
              <Route
                path="/pdcs_reports"
                element={
                  <PDCSReport
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                    setShowCloseButton={setShowCloseButton}
                    setPagePath={setPagePath}
                  />
                }
              />
              <Route
                path="/pending_fee_plan_reports"
                element={
                  <PendingFeePlanReport
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                    setShowCloseButton={setShowCloseButton}
                    setPagePath={setPagePath}
                  />
                }
              />
              <Route
                path="/cashbook_reports"
                element={
                  <CashbookReport
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                    setShowCloseButton={setShowCloseButton}
                    setPagePath={setPagePath}
                  />
                }
              />
               <Route
                path="/quick_test_scheduling"
                element={
                  <QuickTestScheduling
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                    setShowCloseButton={setShowCloseButton}
                    setPagePath={setPagePath}
                  />
                }
              />
                <Route
                path="/quick_dpp_scheduling"
                element={
                  <QuickDPPSchedulingDashboard
                    setMessageBox={setMessageBox}
                    messageBox={messageBox}
                    setIsMessageBoxVisible={setIsMessageBoxVisible}
                    setActiveImg={setActiveImg}
                    dataClient={data}
                    setNoTimeSet={setNoTimeSet}
                    setShowCloseButton={setShowCloseButton}
                    setPagePath={setPagePath}
                  />
                }
              />
            </Routes>
            <p className="landing-dse-sign">Powered by Intellect Roots</p>
            {/* <p className="landing-dse-sign"><img src={CoachingBuddyImg} alt="" /></p> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landing;
